import { useEffect } from "react";

/** Loads web font stylesheets in the page, once per URL. */
export function useWebFontStylesheets(urls: string[]) {
  const key = urls.join("\n");

  useEffect(() => {
    if (!key) return;
    const loaded = new Set(
      Array.from(
        document.querySelectorAll<HTMLLinkElement>("link[data-web-font]"),
      ).map((link) => link.dataset.webFont),
    );

    for (const url of key.split("\n")) {
      if (loaded.has(url)) continue;
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = url;
      link.dataset.webFont = url;
      document.head.appendChild(link);
    }
  }, [key]);
}
